import "./PartnerLanding.scss";

const PartnerLanding = () => {
    return(
        <section className="partner_landing">
            <div className="overlay"></div>
            <div className="content_wrap">
                <h1 className="small_title">For Channel & Vendor Partnerships</h1>
            </div>
        </section>
    )
}

export default PartnerLanding;